
import { Style, Icon } from 'ol/style';
import config from '../config'
const style = (feature) => {

  let images = require.context('../assets/pictos', true);
  
  var thematique = feature.getProperties().thematique;
  var themedupicto = config.contenu.filter(a=>a.thematique===thematique);
  if(themedupicto.length===0)
console.log(thematique)
  return new Style({
    image: new Icon({
      anchor: [0, 46],
      anchorXUnits: 'fraction',
      anchorYUnits: 'pixels',
      scale: 1,
      src: images(`./${themedupicto[0].picto}`)
    }),
  })
}

export default style;